/* eslint-disable class-methods-use-this */
/* eslint-disable react/sort-comp */
/* eslint-disable import/prefer-default-export */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
    FormGroup,
    TextInput,
    DropdownSkeleton,
    DataTableSkeleton,
    TableToolbar,
    Dropdown,
    Search,
    Button,
    DataTable,
    TableContainer,
    Table,
    TableBody,
    Pagination,
    TableHead,
    TableHeader,
    TableRow,
    TableCell,
    Form,
    FormLabel,
    Loading,
    TableSelectRow,
    TableBatchActions,
    TableBatchAction,
    TableToolbarContent,
    ButtonSkeleton,
} from 'carbon-components-react';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Close20 from '@carbon/icons-react/lib/close/20';
import Data16 from '@carbon/icons-react/lib/data--1/16';
import Task16 from '@carbon/icons-react/lib/task/16';
import Report16 from '@carbon/icons-react/lib/report/16';
import { Information16, Calendar16, Model16 } from '@carbon/icons-react';
import DocumentExport16 from '@carbon/icons-react/lib/document--export/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Send16 from '@carbon/icons-react/lib/send/16';
import Error16 from '@carbon/icons-react/lib/error/16';
import Add20 from '@carbon/icons-react/lib/add/20';
import CheckmarkOutline16 from '@carbon/icons-react/lib/checkmark--outline/16';
import InspectionTypeComboBox from './common/InspectionTypeComboBox';
import InspectionSectionComboBox from './common/InspectionSectionComboBox';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import SimpleReactValidator from 'simple-react-validator';
import { AppContext } from '../../helpers/context/AppContext';
import { CanExecuteAction, IsInRole, IsEditable } from '../../helpers/authorization/Policies';
import { me, api, dynamic, inspection, registry } from '../../helpers/api/api';
import { WFActionModal } from '../common/WFActionModal';
import { getError, entitiesLabels, apioperation, getSuccess, NotificationModule } from '../../helpers/Constants';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { ComboBox } from '../../helpers/ComboBox';
import { InspectionMonthHeader } from './common/InspectionMonthHeader';
import { CalendarSkeleton } from './inspectionReport/common/CalendarSkeleton';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import EmailChips from '../../helpers/EmailChips';
import {
    RenderDataTableCell,
    NoRecordsPlaceholder,
} from '../../helpers/jsonschemaform/DataTableExtention';
import { HistoryTable } from '../../helpers/HistoryTable';
import { Online, Offline } from '../common/OnLineOffLine';
import FileDownLoadButton from '../common/FileDownloadButton';
import MeRepository from '../../helpers/api/MeRepository';
import InspectionRepository from '../../helpers/api/InspectionRepository';
// CR 156
import { AsyncFilterContainer } from '../common/AsyncFilterContainer';
import  {WarningModal}  from '../common/WarningModal';//RITM1037347

//RITM0623664_InspectionEstemporanea
const typeEXT = [
    { key: "onlyExt", name: "Only Ext" },
    { key: "notExt", name: "Not Ext" },
]

export class Inspection extends Component {
    inpsectionProps = () => ({
        id: null,
        idDivision: null,
        idWorkSite: null,
        idCompiler: uuid(),//RITM1037347
        idInspectionSection: null,
        idInspectionType: null,
        idProject: null,
        inspectors: [],
        plannedWeek: null,
        referenceYear: null,
        distributionList: null,
        projectArea: null,
        inspectionReport: null,
        //RITM0623664_InspectionEstemporanea
        onlyExt: null,
        notExt: null,
        // FINE RITM0623664
    });

    searchProp = () => {
        let inspectionCode = this.getHashtag();
        return ({
            emailCompiler: '',
            emailDataApprover: '',
            emailDivisionManager: '',
            inspectionCode: inspectionCode,
            idStatus: null,
            idStatusReport: null,
            idDivision: null,
            idWorkSite: null,
            idInspectionSection: null,
            idInspectionType: null,
            idProject: null,
            referenceYear: inspectionCode ? +inspectionCode.toString().slice(-4) : new Date().getFullYear(),
            plannedWeek: null,
            monthNumber: null,
            plannedWeeks: [],
            monthNumbers: [],
        })
    };

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            emailChipsKey: `Email_${new Date().getTime()}`,
            CBChipsKey: `CB_${new Date().getTime()}`,
            calendar: [],
            isLoadingWeeksItems: false,
            currentPage: 1,
            pageSize: 10,
            rowCount: 0,
            inspections: [],
            idStatus: null,
            approverRole: '',
            project: undefined,
            status: [],
            insepctorUser: [],
            isfilterByWeek: false,
            isLoadingDivision: false,
            isLoadingWorksite: false,
            isLoadingProject: false,
            isLoadingInspectors: false,
            isLoadingInspectionType: false,
            isLoadingStatus: false,
            isEditModal: false,
            isOpenCalendar: true,
            isOpenSearchForm: false,
            isOpenModalInspection: false,
            isOpenModalInspectiondetail: false,
            spinner: false,
            isSubmitted: false,
            isLoading: false,
            // InspectionModel
            inspectionModel: {
                ...this.inpsectionProps(),
            },

            searchModel: {
                ...this.searchProp(),
                needToChange: true,
            },
            // WF
            weeksItems: [],
            isDisabled: false,
            isApprovalModalOpen: false,
            approvalModalAction: '',
            approver: null,
            approvalStartDate: null,
            approvalEndDate: null,
            isLoadingApproverOptions: true,
            approvalValidationMessages: [],
            approvers: [],
            selectedData: [],
            withApprover: true,
            isLoadingWFOperation: false,
            approvalNotesRequired: false,
            // History
            isHistoryModalOpen: false,
            //
            weeks: [],
            years: this.getYears(),
            // All
            divisions: [],
            appAllWorksites: null,
            appAllWorksitePrj: null,
            appAllInspectors: null,
            //
            worksites: [],
            projects: [],
            inspectors: [],
            inspecionType: [],
            inspectionSection: [],

            isBack: this.props.history.action === 'POP' || this.props.location.search === '?isBack' ? true : false,
            monthsSelected: [],
            weeksSelected: [],
            allInspectors: [], //RITM1227369
            idReason: null, //RITM1037347
            isReasonModalOpen: false,//RITM1037347
            reason: null,//RITM1037347
            xReasons: [],//RITM1037347
            referenceYear:null,
            isWarningReOpenModalOpen: false//RITM1037347
        };
        this.year = new Date().getFullYear();
        this.years = this.getYears();
        this.month = new Date().getMonth();
        this.updateState = this.updateState.bind(this);
        this.getInspections = this.getInspections.bind(this);
        this.weeks = moment().weeks();
        this.weeks = Array.from(new Array(18), (val, index) => (index + this.weeks).toString());
        this.IsRowSelectable = this.IsRowSelectable.bind(this);
        this.getAllDivision = this.getAllDivision.bind(this);
        this.getAllWorkSite = this.getAllWorkSite.bind(this);
        this.getAllProjects = this.getAllProjects.bind(this);
        this.getInspectors = this.getInspectors.bind(this);
        this.getStatus = this.getStatus.bind(this);
        this.getInspectionType = this.getInspectionType.bind(this);
        this.getInspectionSection = this.getInspectionSection.bind(this);
        this.showDivModaleInspection = this.showDivModaleInspection.bind(this);
        this.showDivModaleInspectionDetail = this.showDivModaleInspectionDetail.bind(this);
        this.onYearChange = this.onYearChange.bind(this);
        this.clearModalInspection = this.clearModalInspection.bind(this);
        this.toggleSearchForm = this.toggleSearchForm.bind(this);
        this.toogleCalendar = this.toogleCalendar.bind(this);
        this.updateState = this.updateState.bind(this);
        this.handleClickCancelSearch = this.handleClickCancelSearch.bind(this);
        this.onSelectSectionChange = this.onSelectSectionChange.bind(this);
    }

    componentDidMount() {

        this.getInspections();
        this.getInspectorsWS();
        this.getAllDivision();
        this.getAllWorkSite();
        this.getAllProjects();
        // this.getInspectors();
        this.getInspectionSection('');
        this.getInspectionType('');
        this.getStatus();
        this.getYears();
        this.getAllInspectionCompilers(); //RITM1227369
        this.getReasons(this.state.referenceYear == null ? this.state.searchModel.referenceYear : this.state.referenceYear);//RITM1037347
    }
    //RITM1037347
    getReasons(year) {
        api
            .getAll(`inspection/reasons/${year}`)
            //.getAll(`inspection/reasons/2024`)
            .then((response) => {             
                this.setState({
                    xReasons: response.data,
                });               
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.INSPECTION, apioperation.GET));
            });} //RITM1037347 end
      
    getHashtag = () => {
        if (this.props.location?.hash != null && this.props.location.hash.length > 1) {
            return decodeURIComponent(this.props.location.hash.substring(1));
        }
        return null;
    };

    weeksInYear(year) {
        let startWeek = 1;
        const weeksInYear = [];
        const today = moment();
        if (today.year() === year) {
            startWeek = today.week();
        }
        for (let i = startWeek; i <= 53; i++) {
            const x = moment(year.toString()).add(i - 1, 'weeks');
            weeksInYear.push({
                id: i,
                name: `Week ${i} :${x.startOf('isoWeek').format('DD/MM/YYYY')} - ${x
                    .endOf('isoWeek')
                    .format('DD/MM/YYYY')}`,
            });
        }
        return weeksInYear;
    }

    getWeekYears(years) {
        this.setState({
            isLoadingWeeksItems: true,
        });
        me.getAll(`weeks/${years}`)
            .then((response) => {
                let listWeek = response.data || [];
                const yearNow = new Date().getFullYear();

                listWeek = listWeek.map((item) => ({
                    id: item.weekNum,
                    name: `Week:${item.name} | ${moment(item.weekStart).format('DD/MM/YYYY')}-${moment(
                        item.weekFinish
                    ).format('DD/MM/YYYY')}`,
                }));
                if (years === yearNow) {
                    const weekNow = moment().isoWeek(); //RITM0536127 moment().week();
                    listWeek = (listWeek || []).filter((el) => el.id >= weekNow || el.id === this.state.inspectionModel?.plannedWeek);
                }
                this.setState({
                    weeksItems: listWeek,
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoadingWeeksItems: false,
                });
            });
    }

    YearList(year) {
        year = moment().year() + 2;
        // if (year == moment().year()) {
        //     year = year + 2;
        // }
        // if (year == moment().year()+1) {
        //     year = year + 1;
        // }
        const years = [
            { id: year - 2, name: (year - 2).toString() },
            { id: year - 1, name: (year - 1).toString() },
            { id: year, name: year.toString() },
            { id: year + 1, name: (year + 1).toString() },
            { id: year + 2, name: (year + 2).toString() },
            { id: year + 3, name: (year + 3).toString() },
        ];
        return years;
    }

    getWorksiteFiltered(idDivision) {
        if (idDivision != null) {
            const data = (this.state.appAllWorksites || []).filter((el) => el.idDivision === idDivision);
            return data;
        }
        return this.state.appAllWorksites;
    }
    getInspectorFiltered(user) {
        if (user != null) {
            const data = (this.state.insepctorUser || []).filter((el) => el.worksite.includes(this.state.inspectionModel?.idWorkSite) || el.divisions.includes(this.state.inspectionModel?.idDivision));

            return data;
        }
        return this.state.insepctorUser;
    }
    getWorksitePrjFiltered(idWorksite) {
        if (idWorksite != null) {
            const data = (this.state.appAllWorksitePrj || []).filter((el) => el.idWorkSite === idWorksite);
            return data;
        }
        return this.state.appAllWorksitePrj;
    }

    DownloadInspectiontNotification(inpsectionId) {
        this.setState({ isLoadingNotificationFile: true });
        api
            .getWithParam(`/inspection/${inpsectionId}/export`, { responseType: 'arraybuffer' })
            .then((response) => {
                const data = new Blob([response.data], { type: 'application/pdf' });
                const csvURL = window.URL.createObjectURL(data);
                const tempLink = document.createElement('a');
                tempLink.href = csvURL;
                const inspectionCode = this.state.inspections.find((i) => i.id === inpsectionId);
                const nomefile = `Inspection_Notification_${inspectionCode.inspectionCode}.pdf`;
                tempLink.setAttribute('download', nomefile);
                document.body.appendChild(tempLink);
                tempLink.click();
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`,
                    getError(error, entitiesLabels.INSPECTION_NOTIFICATION, apioperation.DOWNLOAD)
                );
            })
            .finally(() => {
                this.setState({ isLoadingNotificationFile: false });
            });
    }

    DownloadInspectionReport(inpsectionId) {
        this.setState({ isLoadingNotificationFile: true });
        api
            .getWithParam(`/inspection/${inpsectionId}/exportreport`, {
                responseType: 'arraybuffer',
            })
            .then((response) => {
                const data = new Blob([response.data], { type: 'application/pdf' });
                const csvURL = window.URL.createObjectURL(data);
                const tempLink = document.createElement('a');
                tempLink.href = csvURL;
                const inspectionCode = this.state.inspections.find((i) => i.id === inpsectionId);

                const nomefile = `Inspection_Report_${inspectionCode.inspectionCode}.pdf`;
                tempLink.setAttribute('download', nomefile);
                document.body.appendChild(tempLink);
                tempLink.click();
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`,
                    getError(error, entitiesLabels.INSPECTION_REPORT, apioperation.DOWNLOAD)
                );
            })
            .finally(() => {
                this.setState({ isLoadingNotificationFile: false });
            });
    }

    // FUNCTION
    toggleSearchForm(e) {
        e.preventDefault();
        this.setState((oldState) => ({ isOpenSearchForm: !oldState.isOpenSearchForm }));
        // TODO this.getUserWorksiteFilter();
        // this.getAllProjectsFilter();
    }

    toogleCalendar(e) {
        e.preventDefault();
        this.setState((oldState) => ({ isOpenCalendar: !oldState.isOpenCalendar }));
    }

    // showDivModaleInspection() {
    //   this.setState((oldState) => ({ isOpenModalInspection: !oldState.isOpenModalInspection }));
    // }
    //RITM0623664_InspectionEstemporanea
    showDivModaleInspection(isExt = false) {
        if (isExt) this.setState((oldState) => ({ isOpenModalInspection: !oldState.isOpenModalInspection, inspectionModel: { ...this.state.inspectionModel, isExt: true } }));
        else this.setState((oldState) => ({ isOpenModalInspection: !oldState.isOpenModalInspection }));
    }
    //----FINE RITM0623664

    showDivModaleInspectionDetail() {
        this.setState((oldState) => ({
            isOpenModalInspectiondetail: !oldState.isOpenModalInspectiondetail,
        }));
    }

    clearModalInspection = () => {
        this.setState({
            inspectionModel: this.inpsectionProps(),
            year: undefined,
            week: undefined,
            isEditModal: false,
            isOpenModalInspection: false,
            emailChipsKey: `Email_${new Date().getTime()}`,
            CBChipsKey: `CB_${new Date().getTime()}`,
        });
        this.getAllDivision();
        this.validator.hideMessages();
    };

    async onYearChange(selectedItem) {
        this.setState({
            isfilterByWeek: false,
            isBack: false,
            referenceYear: selectedItem.selectedItem,
        });
        let year;
        try {
            year = selectedItem.selectedItem;
            const yearsNew = this.getYears(year);

            const statusCopy = { ...this.state };
            statusCopy.years = yearsNew;
            statusCopy.searchModel.referenceYear = year;
            statusCopy.searchModel.needToChange = true;
            statusCopy.searchModel.monthNumbers = [];
            statusCopy.searchModel.plannedWeeks = [];
            statusCopy.searchModel.needToChange = true;
            statusCopy.isBack = false;
            this.setState(statusCopy, 
                () =>  {
                    this.getInspections({ page: 1 }, false)
                }
            ); //RITM1258665
            // this.setState({
            //   searchModel: {
            //     ...this.searchProp(),
            //     needToChange: true,
            //   },
            // });
            this.getReasons(year);
        } catch (error) {
            year = this.state.years;
        } finally {
            this.setState({
                referenceYear: year,
                loading: true,
                filteredMonth: null,
                isBack: false,
            });
        }
    }

    handleClickCancelSearch = (e) => {
        e.preventDefault();
        this.toggleSearchForm(e);
        this.setState(
            {
                searchModel: {
                    ...this.searchProp(),
                    needToChange: true,
                },
                worksites: null,
                projects: null,
                isBack: false,
                monthsSelected: [],
                weeksSelected: []
            },
            () => {
                this.getInspections();
            }
        );
    };

    handleChangeComboWorksite = (inputName, selectedItem, objName) => {
        const inputValue = selectedItem ? selectedItem.id : null;
        const inputValueName = selectedItem ? selectedItem.name : null;
        const statusCopy = { ...this.state };
        statusCopy[objName][inputName] = inputValue;
        statusCopy.projects = null;
        statusCopy.inspectionModel.idProject = null;
        statusCopy.inspectionModel.inspectors = [];
        statusCopy.inspectionModel.workSite = inputValueName;
        this.getInspectors(inputValue);
        this.setState(statusCopy);
    };

    handleChangeModel = (el) => {
        const inputName = el.target.name;
        const inputValue = el.target.value;
        const objName = el.target.alt;
        this.updateState(inputName, inputValue, objName);
    };

    handleChangePaging = async (event) => {
        const searchModel = { ...this.state.searchModel };
        searchModel.needToChange = false;
        await this.setState({ searchModel, isBack: false });
        this.getInspections(event);
    };

    onChangeInspector = (inputName, selectedItem, objName) => {
        const statusCopy = { ...this.state };
        statusCopy[objName][inputName][0] = selectedItem;
        this.setState(statusCopy);
    };

    handleChangeComboForFilter = (inputName, selectedItem, objName) => {
        const statusCopy = { ...this.state };

        //RITM0623664_InspectionEstemporanea
        if (inputName === "ext") {
            if (!selectedItem) statusCopy[objName] = { ...statusCopy[objName], onlyExt: null, notExt: null }
            else {
                const onlyExtObj = { onlyExt: true, notExt: null }
                const notExtObj = { onlyExt: null, notExt: true }
                statusCopy[objName] = (selectedItem?.key === "onlyExt") ? { ...statusCopy[objName], ...onlyExtObj } : { ...statusCopy[objName], ...notExtObj }
            }
            this.setState(statusCopy);
            return
        }
        //FINE RITM0623664_InspectionEstemporanea

        const inputValue = selectedItem ? selectedItem.id : null;
        //statusCopy.isBack = false;
        statusCopy[objName][inputName] = inputValue;

        if (inputName === 'idDivision') {
            statusCopy.worksites = null;
            statusCopy.searchModel.idWorkSite = null;
            statusCopy.searchModel.idProject = null;
        }
        if (inputName === 'idWorkSite') {
            statusCopy.project = null;
            statusCopy.searchModel.idProject = null;
        }
        if (inputName === 'idProject') {
            statusCopy[objName][inputName] = selectedItem?.idProject;
        }
        this.setState(statusCopy);
    };

    handleChangeModel = (el) => {
        const inputName = el.target.name;
        const inputValue = el.target.value;
        const objName = el.target.alt;
        this.updateState(inputName, inputValue, objName);
    };

    handleChangeCombo = (inputName, selectedItem, objName) => {
        const inputValue = selectedItem ? selectedItem.id : null;
        const inputValueName = selectedItem ? selectedItem.name : null;
        const statusCopy = { ...this.state };
        statusCopy[objName][inputName] = inputValue;

        if (inputName === 'idDivision') {
            statusCopy.inspectionModel.division = inputValueName;
            statusCopy.worksites = null;
            statusCopy.inspectionModel.idWorkSite = null;
            statusCopy.inspectionModel.idProject = null;            
        }
        if(inputName==='idReason')
        {
            statusCopy.reason = inputValue;
        }
        if (inputName === 'idWorkSite') {
            statusCopy.inspectionModel.workSite = inputValueName;
        }
        if (inputName === 'idInspectionSection') {
            statusCopy.inspectionModel.inspectionSection = inputValueName;
        }
        if (inputName === 'idInspectionType') {
            statusCopy.inspectionModel.inspectionType = inputValueName;
        }
        if (inputName === 'idProject') {
            statusCopy[objName][inputName] = selectedItem?.idProject;
        }

        this.setState(statusCopy);
    };

    handleChangeComboDate = (inputName, selectedItem, objName) => {
        const inputValue = selectedItem ? selectedItem.id : null;
        const statusCopy = { ...this.state };

        statusCopy[objName][inputName] = inputValue;
        statusCopy[objName].plannedWeek = null;
        this.setState(statusCopy);
        if (inputValue != null) this.getWeekYears(inputValue);
    };

    // DEV 156
    handleApproveReportCheck = (user) => {
        if (this.state.inspectors == null || this.state.inspectors?.length == 0) return null;
        else return this.state.inspectors.some(inspector => inspector.id === user.id)
    }

    onSelectSectionChange = (selectedItem) => {
        this.setState((prevState) => {
            const inspectionModel = { ...prevState.inspectionModel };
            inspectionModel.inspectionSection = selectedItem || {};
            inspectionModel.inspectionType = {};
            return { inspectionModel };
        });
    };
    onSelectInspectionTypeChange = (selectedItem) => {
        this.setState((prevState) => {
            const inspectionModel = { ...prevState.inspectionModel };
            inspectionModel.inspectionType = selectedItem || null;
            return { inspectionModel };
        });
    };

    handleChangeComboDateWeek = (inputName, selectedItem, objName) => {
        const inputValue = selectedItem ? selectedItem.id : null;
        const statusCopy = { ...this.state };

        statusCopy[objName][inputName] = inputValue;
        this.setState(statusCopy);
    };

    updateState = (inputName, inputValue, objName) => {
        const statusCopy = { ...this.state };
        statusCopy[objName][inputName] = inputValue;
        statusCopy.isBack = false;
        this.setState(statusCopy);
    };

    filterByWeek = (weekNumber) => {
        let year;
        try {
            year = this.state.searchModel.referenceYear ? this.state.searchModel.referenceYear : null;
            const statusCopy = { ...this.state };
            statusCopy.searchModel.referenceYear = year;

            const index = statusCopy.searchModel.plannedWeeks.indexOf(weekNumber);
            if (index > -1) statusCopy.searchModel.plannedWeeks.splice(index, 1);
            else statusCopy.searchModel.plannedWeeks.push(weekNumber);

            statusCopy.searchModel.needToChange = false;
            statusCopy.isfilterByWeek = true;
            this.setState(statusCopy, 
                () => {
                    this.getInspections({ page: 1 }, true)
                }
            ); //RITM1258665
        } catch (error) {
            showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, apioperation.GET));
        } finally {
        }
    };

    filterByMonths = (month) => {
        let year;
        try {
            year = this.state.searchModel.referenceYear ? this.state.searchModel.referenceYear : null;
            const statusCopy = { ...this.state };
            statusCopy.searchModel.referenceYear = year;
            const index = statusCopy.searchModel.monthNumbers.indexOf(month.monthsNumber);
            if (index > -1) statusCopy.searchModel.monthNumbers.splice(index, 1);
            else statusCopy.searchModel.monthNumbers.push(month.monthsNumber);
            statusCopy.isBack = false;
            statusCopy.searchModel.needToChange = false;
            statusCopy.isfilterByWeek = true;
            statusCopy.monthsSelected = this.state.monthsSelected.filter((el) => el != month.monthsNumber);
            this.setState(statusCopy, 
                () => {
                    this.getInspections({ page: 1 }, true)
                }
            ); //RITM1258665
            // this.setState({
            //    searchModel: {
            //        ...this.searchProp(),
            //    }
            // })
        } catch (error) {
            showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, apioperation.GET));
        } finally {
        }
    };

    // GET PROPS

    getInspectionSection(parent) {
        this.setState({
            isLoadingInspectionSection: true,
        });
        dynamic
            .getAll('inspectionsection', { params: { page: 0, parent } })
            .then((response) => {
                const data = response.data.itemList;
                this.setState({

                    inspectionSection: data,
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WORKPROCESS, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoadingInspectionType: false,
                });
            });
    }

    getInspectionType(parent) {
        this.setState({
            isLoadingInspectionType: true,
        });
        dynamic
            .getAll('inspectiontype', { params: { page: 0, parent } })
            .then((response) => {
                const data = response.data.itemList;
                this.setState({
                    inspecionType: data,
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WORKPROCESS, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoadingInspectionType: false,
                });
            });
    }

    getStatus = () => {
        this.setState({
            isLoadingStatus: true,
        });
        registry
            .getAll('status')
            .then((response) => {
                const { data } = response;
                this.setState({
                    status: data,
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.STATUS, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoadingStatus: false,
                });
            });
    };
    getInspectorsWS = () => {
        this.setState({
            isLoadingInspectors: true,
        });
        api.getAll(`/users/userworksite/${NotificationModule.ModuleInspection}`)
            .then((response) => {
                const { data } = response;
                this.setState({
                    insepctorUser: data,
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION_NOTIFICATION, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoadingInspectors: false,
                });
            });
    };
    getUserWorksite = (id) => {
        if (id == null) return;
        this.setState({
            isLoadingWorksite: true,
        });
        me.getAll(`division/${id}/worksites`)
            .then((response) => {
                this.setState({
                    worksites: response.data,
                    worksitesFilter: response.data,
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WORKSITE, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoadingWorksite: false,
                });
            });
    };

    getAllProjectsForWorksite = (id) => {
        if (id == null) return;
        this.setState({
            isLoadingProject: true,
        });
        api
            .getAll(`project/worksite/${id}/projects`)
            .then((response) => {
                this.setState({
                    projects: response.data,
                    projectsFilter: response.data,
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.PROJECT, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoadingProject: false,
                });
            });
    };

    // GETALL
    getAllDivision = () => {
        this.setState({
            isLoadingDivision: true,
        });
        MeRepository.getDivisions()
            .then((response) => {
                this.setState({
                    divisions: response,
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.DIVISION, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoadingDivision: false,
                });
            });
    };
    getInspectionCode(id) {
        const inspectionCode = this.state.inspections.filter(x => x.id === id);
        return "Inspection_Notification_" + inspectionCode[0].inspectionCode + ".pdf"
    }
    getInspectionReportCode(id) {
        const inspectionCode = this.state.inspections.filter(x => x.id === id);
        return "Inspection_Report_" + inspectionCode[0].inspectionCode + ".pdf"
    }
    getAllWorkSite = () => {
        this.setState({
            isLoadingWorksite: true,
        });
        me.getAll('worksites')
            .then((response) => {
                this.setState({
                    appAllWorksites: response.data,
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WORKSITE, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoadingWorksite: false,
                });
            });
    };

    getAllProjects = () => {
        this.setState({
            isLoadingProject: true,
        });
        api
            .getAll('/me/worksitesproject')
            .then((response) => {
                this.setState({
                    appAllWorksitePrj: response.data,
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.PROJECT, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoadingProject: false,
                });
            });
    };

    getInspectors(idWorkSite) {
        if (idWorkSite == null) return;
        this.setState({
            isLoadingInspectors: true,
        });
        this.setState({
            inspectors: [],
        });
        api
            .get('inspection/inspectors/', idWorkSite)
            .then((response) => {
                this.setState({
                    inspectors: response.data,
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoadingInspectors: false,
                });
            });
    }

    getYears = () => {
        const year = moment().year() + 2;

        //  var years = [
        //      { id: year - 2, name: (year - 2).toString() },
        //      { id: year - 1, name: (year - 1).toString() },
        //      { id: year, name: (year).toString() },
        //      { id: year + 1, name: (year + 1).toString() },
        //      { id: year + 2, name: (year + 2).toString() },
        //      { id: year + 3, name: (year + 3).toString() },
        //      { id: year + 4, name: (year + 4).toString() }
        //  ];
        // return years;
        // ANNI VARIABILI
        //     if (selectYear == null) selectYear = new Date().getFullYear();
        //     const year = new Date(selectYear, null, null).getFullYear();
        const yearsArray = []; //RITM0771499

        for (var i = 2021; i <= year + 3; i++) {
            yearsArray.push(i.toString());
        } //RITM0771499

        return yearsArray;
    };

    getUsersInRole = (role, appModule, idWorksite, idDivision) => { //RITM1064131
        me.getWithParam('getuserbyroleandmodule', { //RITM1064131
            params: { Role: role, appModule: appModule, idWorksites: idWorksite, IdDivision: idDivision, includeAdmins: true }, //RITM1064131
        })
            .then((response) => {
                this.setState({
                    approvers: response.data,
                    isLoadingApproverOptions: false,
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.ROLE, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoadingApproverOptions: false,
                });
            });
    };

    setLoading = (isLoading, isFinally) => {
        if (isFinally) {
            if (this.state.searchModel.plannedWeek == null) {
                this.setState({
                    isLoadingList: false,
                    isLoadingElement: false,
                    isLoadingCalendar: false,
                });
            } else {
                this.setState({
                    isLoadingList: false,
                    isLoadingDate: false,
                    isLoadingElement: false,
                });
            }
        } else if (isLoading) {
            if (this.state.searchModel.plannedWeek == null) {
                this.setState({
                    isLoadingList: true,
                    isLoadingElement: true,
                    isLoadingCalendar: true,
                });
            } else {
                this.setState({
                    isLoadingList: true,
                    isLoadingElement: true,
                });
            }
        } else if (this.state.searchModel.plannedWeek == null) {
            this.setState({
                isLoadingList: false,
                isLoadingDate: false,
                isLoadingElement: false,
                isLoadingCalendar: false,
            });
        } else {
            this.setState({
                isLoadingList: false,
                isLoadingElement: false,
                isfilterByWeek: false,
            });
        }
    };

    getInspections = async (param, back) => {

        let data = null;
        if (!this.state.isBack || back || this.state.searchModel.inspectionCode) {
            data = {
                params: {
                    page: param && param.page ? param.page : this.state.currentPage,
                    pageSize: param && param.pageSize ? param.pageSize : this.state.pageSize,
                    ...this.state.searchModel,
                    plannedWeeks: this.state.searchModel.plannedWeeks?.join(','),
                    monthNumbers: this.state.searchModel.monthNumbers?.join(','),
                    needToChange: this.state.searchModel.needToChange,
                },
            };

            // RITM0558173 commentate le seguenti 2 righe perche errate come spiega il ticket
            // data.params.page = this.state.currentPage; 
            // data.params.pageSize = this.state.pageSize;
        } else {
            let filter = await InspectionRepository.getBackPaged();
            let stateFilter = filter?.params;
            let weeks = stateFilter.plannedWeeks != '' ? stateFilter.plannedWeeks.split(',') : [];
            let weekInt = weeks.map((el) => parseInt(el));
            let month = stateFilter.monthNumbers != '' ? stateFilter.monthNumbers.split(',') : [];
            let monthInt = month.map((el) => parseInt(el));
            this.setState({
                searchModel: {
                    emailCompiler: filter?.params.emailCompiler,
                    emailDataApprover: filter?.params.emailDataApprover,
                    emailDivisionManager: filter?.params.emailDivisionManager,
                    inspectionCode: filter?.params.inspectionCode,
                    idStatus: filter?.params.idStatus,
                    idStatusReport: filter?.params.idStatusReport,
                    idDivision: filter?.params.idDivision,
                    idWorkSite: filter?.params.idWorkSite,
                    idInspectionSection: filter?.params.idInspectionSection,
                    idInspectionType: filter?.params.idInspectionType,
                    idProject: filter?.params.idProject,
                    referenceYear: filter?.params.referenceYear,
                    plannedWeek: weekInt,
                    monthNumber: monthInt,
                    plannedWeeks: weekInt,
                    monthNumbers: monthInt,
                    needToChange: filter?.params.needToChange, //RITM1258665
                },
                monthsSelected: monthInt,
                weeksSelected: weekInt
            });
            if (filter?.params) filter.params.plannedWeeks = weekInt?.join(',');
            data = {
                params: filter?.params,
            };
            //RITM0558173
            data.params.page = 1
            //
            let calendarfilter = await InspectionRepository.getBackPagedCalendar()
            this.setState({
                calendar: calendarfilter.events.fourMonthsList,
            });

        }
        this.getInspectionsFilter(data);     
    }

    getInspectionsFilter(filter) {
        this.setLoading(true, false);
        inspection
            .getCalendar(filter)
            .then((response) => {
                if (response.status === 200) {
                    const { data } = response;
                    response.data.itemList.forEach(
                        (x) =>
                        (x.plannedWeek =
                            x.inspectionPlannedWeeks.length > 0 ? x.inspectionPlannedWeeks[0].weekNumber : null)
                    );
                    InspectionRepository.updateInspectionFilter(filter);
                    this.setState({
                        data,
                        currentPage: data.currentPage,
                        pageSize: data.pageSize,
                        rowCount: data.rowCount,
                        inspections: data.itemList,
                    });

                    if (this.state.searchModel.needToChange && !this.state.isBack) {
                        this.setState({
                            calendar: data.events.fourMonthsList,
                        });
                        InspectionRepository.updateInspectionCalendarFilter(data);
                    }

                    this.setLoading(false, false);
                } else {
                    showNotification.error();
                }
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, apioperation.GET));
            })
            .finally(() => {
                this.setLoading(true, true);
            });
    }

    handleClickSearch = (e) => {
        e.preventDefault();
        const searchModel = { ...this.state.searchModel };
        searchModel.needToChange = true;
        this.setState({ searchModel }, 
            () => {
                this.getInspections({ page: 1 }, true)
            }
        ); //RITM1258665
        this.state.searchModel.needToChange = true;
        this.toggleSearchForm(e);
    };

    // ///INSERT INSPECTION  ///UPDATE
    insertNewInspection = () => {
        if (this.validator.allValid()) {
            this.setState({
                isSubmitted: true,
                spinner: true,
            });

            const datiForm = this.state?.inspectionModel;

            if (!this.state.isEditModal) {
                datiForm.id = uuid();

                datiForm.idStatus = 1;
                datiForm.status = 'Draft';
            }
            datiForm.IdSection = this.state?.inspectionModel?.inspectionSection.id;
            datiForm.idInspectionType = this.state?.inspectionModel?.inspectionType.id;
            datiForm.plannedWeek = parseInt(datiForm.plannedWeek, 10);

            datiForm.referenceYear = parseInt(datiForm.referenceYear, 10);

            datiForm.needToChange = true;

            datiForm.inspectionPlannedWeeks = [
                {
                    idInspection: this.state.inspectionModel.id,
                    quantity: 1,
                    weekNumber: parseInt(datiForm.plannedWeek, 10),
                },
            ];
            const year = this.state.searchModel.referenceYear;
            const method = this.state.isEditModal
                ? inspection.put(datiForm, this.state.inspectionModel.id)
                : inspection.post(datiForm);

            method
                .then(async (response) => {
                    if (response.status === 200) {
                        showNotification.success(`${entitiesLabels.SUCCESS}`, 'Successfully saved');
                        await InspectionRepository.updateCachedInspectionList(datiForm);
                        await InspectionRepository.updateCachedInspection(datiForm);
                        // this.showDivModaleInspection();
                        this.clearModalInspection();
                    } else {
                        showNotification.error(`${entitiesLabels.ERROR}`,
                            getError('Unsuccessfully saved', entitiesLabels.INSPECTION, apioperation.POST)
                        );
                    }
                })
                .catch((error) => {
                    showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, apioperation.POST));
                })
                .finally(() => {
                    this.setState(
                        {
                            searchModel: {
                                emailCompiler: '',
                                emailDataApprover: '',
                                emailDivisionManager: '',
                                inspectionCode: this.getHashtag(),
                                idStatus: null,
                                idStatusReport: null,
                                idDivision: null,
                                idWorkSite: null,
                                idInspectionSection: null,
                                idInspectionType: null,
                                idProject: null,
                                referenceYear: year,
                                plannedWeek: null,
                                monthNumber: null,
                                plannedWeeks: [],
                                monthNumbers: [],
                                needToChange: true,
                            },
                            worksites: null,
                            projects: null,
                            isSubmitted: false,
                            spinner: false,
                        },
                        () => {
                            this.getInspections();
                            this.forceUpdate();
                        }
                    );
                });
        } else {
            this.validator.showMessages();
            showNotification.warning(`${entitiesLabels.WARNING}`,
                `${entitiesLabels.INSPECTION} required fields are missing  `
            );
            this.forceUpdate();
        }
    };

    getInspectionEdit(id) {
        this.setState({
            isEditModal: true,
            isOpenModalInspection: true,
            isLoadingElement: true,
        });

        inspection
            .get(id)
            .then((response) => {
                this.validator.hideMessages();

                const plannedWeek =
                    response.data.inspectionPlannedWeeks.length > 0
                        ? response.data.inspectionPlannedWeeks[0].weekNumber
                        : null;
                response.data.plannedWeek = plannedWeek;
                this.setState(
                    {
                        inspectionModel: response.data,
                    },
                    this.getInspectors(response.data.idWorkSite)
                );
                this.getWeekYears(response.data.referenceYear);
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, apioperation.GET));
            })
            .finally(() => {
                this.validator.hideMessages();
                this.setState(
                    {
                        isLoadingElement: false,
                    },
                    () => {
                        // this.getSelectedEntityRoles();
                    }
                );
            });
    }

    // //COMPONENT
    modalNewInspection(user) {
        const listOfWeeks = this.state.inspectionModel?.referenceYear ? this.state.weeksItems : null;
        const listOfYears = this.YearList(this.state.inspectionModel?.referenceYear || moment().year());

        const listWorksite = this.state.inspectionModel.idDivision
            ? this.getWorksiteFiltered(this.state.inspectionModel.idDivision)
            : [];
        const listProject = this.state.inspectionModel.idWorkSite
            ? this.getWorksitePrjFiltered(this.state.inspectionModel.idWorkSite)
            : [];
        const listInspectors = this.state.inspectionModel.idWorkSite
            ? this.getInspectorFiltered(user)
            : [];
        const validations = {
            // type: this.validator.message('type', this.state.model.owner.type, 'required'),
            // division: this.validator.message(
            //     'division',
            //     this.state.inspectionModel.idDivision,
            //     'required'
            // ), //RITM0945977
            division: this.validator.message(
                'businessLine',
                this.state.inspectionModel.idDivision,
                'required'
            ),
            worksite: this.validator.message(
                'worksite',
                this.state.inspectionModel.idWorkSite,
                'required'
            ),
            project: this.validator.message('project', this.state.inspectionModel.idProject, 'required'),
            // DEV 156
            //inspectors: this.validator.message(
            //  'inspector',
            //  this.state.inspectionModel.inspectors,
            //  'required'
            //),
            inspectionType: this.validator.message(
                'inspection type',
                this.state.inspectionModel?.inspectionType?.id,
                'required'
            ),
            distributionList: this.validator.message(
                'distribution list',
                this.state.inspectionModel.distributionList,
                this.state.inspectionModel.isExt ? "" : 'required'
            ),
            referenceYear: this.validator.message(
                'reference year',
                this.state.inspectionModel.referenceYear,
                'required'
            ),
            plannedWeek: this.validator.message(
                'planned week',
                this.state.inspectionModel.plannedWeek,
                'required'
            ),
            section: this.validator.message(
                'Section',
                this.state.inspectionModel?.inspectionSection?.id,
                'required'),
        };
        const selectedItemCombo = {
            idDivision: this.state.inspectionModel.idDivision
                ? (this.state.divisions || []).find((el) => el.id === this.state.inspectionModel?.idDivision)
                : [],
            idWorkSite: this.state.inspectionModel.idWorkSite
                ? (listWorksite || []).find((el) => el.id === this.state.inspectionModel.idWorkSite)
                : [],
            idProject: this.state.inspectionModel.idProject
                ? (listProject || []).find((el) => el.idProject === this.state.inspectionModel.idProject)
                : [],
            inspectors: this.state.inspectionModel.inspectors
                ? (listInspectors || []).find((el) => el.id === this.state?.inspectionModel?.inspectors[0]?.id)
                : [],
            idInspectionSection: this.state.inspectionModel.idInspectionSection
                ? (this.state.inspectionSection || []).find(
                    (el) => el.id === this.state.inspectionModel.idInspectionSection
                )
                : [],
            idInspectionType: this.state.inspectionModel.idInspectionType
                ? (this.state.inspecionType || []).find(
                    (el) => el.id === this.state.inspectionModel.idInspectionType
                )
                : [],
            referenceYear: this.state.inspectionModel.referenceYear
                ? (listOfYears || []).find((el) => el.id === this.state.inspectionModel.referenceYear)
                : [],
            // plannedWeek:  this.state.inspectionModel.plannedWeek ?(listOfWeeks || []).find(el => el.id == this.state.inspectionModel?.plannedWeek) : [],
            plannedWeek: this.state.inspectionModel.plannedWeek
                ? (listOfWeeks || []).find((el) => el.id === this.state.inspectionModel?.plannedWeek)
                : [],
        };
        //RITM0623664_InspectionEstemporanea
        let modalTitle = this.state.isEditModal ? 'UPDATE INSPECTION ' : 'ADD NEW INSPECTION';
        if (this.state.inspectionModel?.isExt) {
            modalTitle += " REPORT"
        }
        //---FINE RITM0623664
        return (
            <AppContext.Consumer>
                {({ user }) => (
                    <>
                        <div style={{ display: this.state.isOpenModalInspection ? 'block' : 'none' }}>
                            <div className="bx--modal bx--modal-tall is-visible">
                                  {/* RITM1037347 */}
                                  {!this.state.isReasonModalOpen ? '' : this.divModalReopenReason()}      
                                            {this.state.isWarningReOpenModalOpen ? (
                                                <WarningModal
                                                    message="Are you sure that you want to reopen the Inspection plan?"
                                                    onCancel={this.toggleWarningReOpenModal}
                                                    onConfirm={this.handleConfirmReOpenSubmit}
                                                />
                                            ) : null}  
                            {/* RITM1037347 end */}

                                <div className="bx--modal-container modal-container-custom">
                                    <div className="modal-header">
                                        <div className="bx--modal-header selection-items-list-costum">
                                            <h3 className="bx--modal-header__heading">
                                                {modalTitle}
                                            </h3>
                                        </div>
                                        <Button
                                            renderIcon={Close20}
                                            iconDescription="Folder"
                                            kind="ghost"
                                            className="close-modal selection-items-list-costum-r"
                                            onClick={this.clearModalInspection}
                                        />
                                    </div>                                        
                                    <div>
                                             
                                        {this.state.isEditModal && this.showButtonHistory()}
                                        {
                                            <HistoryTable
                                                entityId={this.state.inspectionModel.id}
                                                isOpenModal={this.state.isHistoryModalOpen}
                                                onClose={() => this.closeModalHistory()}
                                                masked={this.state.inspectionModel.maskedValue} //RITM0946005 - Anonimizzazione Modulo Inspection
                                            />
                                        }
                                         
                                        {(this.state.isEditModal && 
                                         (this.getStatusId(this.state.inspectionModel.id)== 4 && (this.state.xReasons.length > 0) &&
                                         (this.state.inspectionModel.idCompiler == user.id ||user.roles.includes('Administrator'))))?
                                         
                                          (<Button  onClick={this.toggleReasonModal}>
                                             Reopen
                                            </Button>):''}
                                                                               </div>

                                    <Form className="bx--grid--full-width form--multi ">
                                        {this.state.isLoadingElement && <Loading />}
                                        <div className="bx--row ">
                                            <FormGroup legendText="" className="bx--col-md-4">
                                                {/* RITM0945977 */}
                                                {/* <FormLabel>Division*</FormLabel> */}
                                                <FormLabel>Business Line*</FormLabel>
                                                {this.state.isLoadingDivision ? (
                                                    <DropdownSkeleton />
                                                ) : (
                                                    <ComboBox
                                                        key={'idDivision_' + selectedItemCombo.idDivision}
                                                        id="idDivision"
                                                        placeholder="Select"
                                                        name="idDivision"
                                                        alt="inspectionModel"
                                                        onChange={this.handleChangeCombo}
                                                        itemToString={(item) => (item ? item.name : '')}
                                                        initialSelectedItem={
                                                            selectedItemCombo.idDivision ? selectedItemCombo.idDivision : {}
                                                        }
                                                        items={this.state.divisions}
                                                        disabled={
                                                            this.state.isDisabled ||
                                                            this.state?.divisions == null ||
                                                            this.state?.divisions?.length <= 0 ||
                                                            (this.state.isEditModal &&
                                                                !IsEditable(
                                                                    'Inspection',
                                                                    'Planning',
                                                                    user,
                                                                    this.getStatusId(this.state.inspectionModel.id),
                                                                    'All',
                                                                    this.getCanEditResource(this.state.inspectionModel.id)
                                                                ))
                                                        }
                                                        invalid={validations.division != null}
                                                    />
                                                )}
                                                {validations.division}
                                            </FormGroup>
                                            <FormGroup legendText="" className="bx--col-md-4">
                                                <FormLabel>Worksite*</FormLabel>
                                                {this.state.isLoadingWorksite ? (
                                                    <DropdownSkeleton />
                                                ) : (
                                                    <ComboBox
                                                        id="idWorkSite"
                                                        key={'idWorkSite_' + selectedItemCombo.idWorkSite}
                                                        placeholder="Select"
                                                        name="idWorkSite"
                                                        alt="inspectionModel"
                                                        onChange={this.handleChangeComboWorksite}
                                                        itemToString={(item) => (item ? item.name : '')}
                                                        initialSelectedItem={selectedItemCombo.idWorkSite}
                                                        items={listWorksite}
                                                        disabled={
                                                            this.state.isDisabled ||
                                                            this.state.inspectionModel.idDivision == null ||
                                                            listWorksite == null ||
                                                            listWorksite?.length <= 0 ||
                                                            (this.state.isEditModal &&
                                                                !IsEditable(
                                                                    'Inspection',
                                                                    'Planning',
                                                                    user,
                                                                    this.getStatusId(this.state.inspectionModel.id),
                                                                    'All',
                                                                    this.getCanEditResource(this.state.inspectionModel.id)
                                                                ))
                                                        }
                                                        invalid={validations?.worksite != null}
                                                    />
                                                )}
                                                {validations.worksite}
                                            </FormGroup>
                                            <FormGroup legendText="" className="bx--col-md-4">
                                                <FormLabel className="some-class">Project*</FormLabel>
                                                {this.state.isLoadingProject ? (
                                                    <DropdownSkeleton />
                                                ) : (
                                                    <ComboBox
                                                        id="idProject"
                                                        key={'idProject_' + selectedItemCombo.idProject}
                                                        placeholder="Select"
                                                        name="idProject"
                                                        alt="inspectionModel"
                                                        onChange={this.handleChangeCombo}
                                                        itemToString={(item) => (item ? item.project : '')}
                                                        initialSelectedItem={selectedItemCombo.idProject}
                                                        items={listProject}
                                                        disabled={
                                                            this.state.inspectionModel.idDivision == null ||
                                                            this.state.inspectionModel.idWorkSite == null ||
                                                            listProject == null ||
                                                            listProject?.length <= 0 ||
                                                            (this.state.isEditModal &&
                                                                !IsEditable(
                                                                    'Inspection',
                                                                    'Planning',
                                                                    user,
                                                                    this.getStatusId(this.state.inspectionModel.id),
                                                                    'All',
                                                                    this.getCanEditResource(this.state.inspectionModel.id)
                                                                ))
                                                        }
                                                        invalid={validations.idProject != null}
                                                    />
                                                )}
                                                {validations.project}
                                            </FormGroup>

                                            {/*<FormGroup legendText="" className="bx--col-md-4">*/}
                                            {/*  <FormLabel className="some-class">Inspector</FormLabel>*/}

                                            {/*  {this.state.isLoadingInspectors ? (*/}
                                            {/*    <DropdownSkeleton />*/}
                                            {/*                      ) : (*/}
                                            {/*    <ComboBox*/}
                                            {/*                                  key={this.state.CBChipsKey}*/}
                                            {/*                                  id="inspectors"*/}
                                            {/*                                  placeholder="Select"*/}
                                            {/*                                  name="inspectors"*/}
                                            {/*                                  alt="inspectionModel"*/}
                                            {/*                                  onChange={this.onChangeInspector}*/}
                                            {/*                                  itemToString={(item) => (item ? item.email : '')}*/}
                                            {/*                                  initialSelectedItem={*/}
                                            {/*                                      this.state.inspectionModel.idWorkSite != null*/}
                                            {/*                                          ? selectedItemCombo?.inspectors*/}
                                            {/*                                          : 'Select'*/}
                                            {/*                                  }*/}
                                            {/*                                  items={listInspectors}*/}
                                            {/*                                  disabled={*/}
                                            {/*                                      this.state.inspectionModel.idWorkSite == null ||*/}
                                            {/*                                      this.state.inspectors == null ||*/}
                                            {/*                                      this.state.inspectors?.length <= 0 ||*/}
                                            {/*                                      (this.state.isEditModal &&*/}
                                            {/*                                          !IsEditable(*/}
                                            {/*                                              'Inspection',*/}
                                            {/*                                              'Planning',*/}
                                            {/*                                              user,*/}
                                            {/*                                              this.getStatusId(this.state.inspectionModel.id),*/}
                                            {/*                                              'All',*/}
                                            {/*                                              this.getCanEditResource(this.state.inspectionModel.id)*/}
                                            {/*                                          ))*/}
                                            {/*                                  }*/}
                                            {/*                                  invalid={validations.inspectors != null}*/}
                                            {/*   />*/}
                                            {/*                      )*/}
                                            {/*                      }*/}
                                            {/*  //*/}{/*{validations.inspectors}*/}
                                            {/*</FormGroup>*/}
                                            <FormGroup legendText="" className="bx--col-md-4">
                                                <FormLabel className="some-class">Project Area</FormLabel>
                                                <TextInput
                                                    id="projectArea"
                                                    name="projectArea"
                                                    alt="inspectionModel"
                                                    placeholder="Input project Area"
                                                    value={this.state?.inspectionModel?.projectArea || ''}
                                                    disabled={
                                                        this.state.isDisabled ||
                                                        (this.state.isEditModal &&
                                                            !IsEditable(
                                                                'Inspection',
                                                                'Planning',
                                                                user,
                                                                this.getStatusId(this.state.inspectionModel.id),
                                                                'All',
                                                                this.getCanEditResource(this.state.inspectionModel.id)
                                                            ))
                                                    }
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    labelText=""
                                                />
                                            </FormGroup>

                                            <FormGroup legendText="" className="bx--col-md-4">
                                                <FormLabel className="some-class">Reference Year*</FormLabel>

                                                <ComboBox
                                                    key={"referenceYear_" + selectedItemCombo.referenceYear}
                                                    id="referenceYear"
                                                    placeholder="Select"
                                                    name="referenceYear"
                                                    alt="inspectionModel"
                                                    className="open-up-combo-box"
                                                    onChange={this.handleChangeComboDate}
                                                    itemToString={(item) => item.name || ''}
                                                    initialSelectedItem={selectedItemCombo.referenceYear}
                                                    items={listOfYears}
                                                    disabled={
                                                        this.state.isDisabled ||
                                                        (this.state.isEditModal &&
                                                            !IsEditable(
                                                                'Inspection',
                                                                'Planning',
                                                                user,
                                                                this.getStatusId(this.state.inspectionModel.id),
                                                                'All',
                                                                this.getCanEditResource(this.state.inspectionModel.id)
                                                            ))
                                                    }
                                                    invalid={validations.referenceYear != null}
                                                />
                                                {validations.referenceYear}
                                            </FormGroup>

                                            <FormGroup legendText="" className="bx--col-md-4">
                                                <FormLabel>Inspection Section*</FormLabel>
                                                <InspectionSectionComboBox
                                                    key={'idInspectionSection_' + this.state.inspectionModel?.inspectionSection?.name}
                                                    invalid={validations.section != null}
                                                    invalidText={validations.section}
                                                    onChange={this.onSelectSectionChange}
                                                    onError={(error) => {
                                                        showNotification.error(
                                                            `${entitiesLabels.ERROR}`,
                                                            getError(error, entitiesLabels.SECTION, apioperation.GET)
                                                        );
                                                    }}
                                                    selectedItem={this.state.inspectionModel?.inspectionSection}
                                                    disabled={
                                                        this.state.isDisabled ||
                                                        (this.state.isEditModal &&
                                                            !IsEditable(
                                                                'Inspection',
                                                                'Planning',
                                                                user,
                                                                this.getStatusId(this.state.inspectionModel.id),
                                                                'All',
                                                                this.getCanEditResource(this.state.inspectionModel.id)
                                                            ))
                                                    }
                                                />
                                            </FormGroup>

                                            <FormGroup legendText="" className="bx--col-md-4">
                                                <FormLabel>Inspection Type*</FormLabel>
                                                <InspectionTypeComboBox
                                                    invalid={validations.inspectionType != null}
                                                    invalidText={validations.inspectionType}
                                                    onChange={this.onSelectInspectionTypeChange}
                                                    onError={(error) => {
                                                        showNotification.error(
                                                            `${entitiesLabels.ERROR}`,
                                                            getError(error, entitiesLabels.inspectionType, apioperation.GET)
                                                        );
                                                    }}
                                                    section={this.state.inspectionModel?.inspectionSection?.id}
                                                    key={'idInspectionType_' + this.state.inspectionModel?.inspectionSection?.id}
                                                    initialSelectedItem={this.state.inspectionModel?.inspectionType}
                                                    disabled={
                                                        this.state.isDisabled ||
                                                        this.state.inspectionModel?.inspectionSection?.id === null ||
                                                        (this.state.isEditModal &&
                                                            !IsEditable(
                                                                'Inspection',
                                                                'Planning',
                                                                user,
                                                                this.getStatusId(this.state.inspectionModel.id),
                                                                'All',
                                                                this.getCanEditResource(this.state.inspectionModel.id)
                                                            ))
                                                    }
                                                />
                                            </FormGroup>



                                            <FormGroup legendText="" className="bx--col-md-4">
                                                <FormLabel className="some-class">Reference Week*</FormLabel>
                                                {!this.state.isLoadingWeeksItems ? (
                                                    <ComboBox
                                                        key={'plannedWeek_' + selectedItemCombo.plannedWeek}
                                                        id="plannedWeek"
                                                        placeholder="Select"
                                                        name="plannedWeek"
                                                        alt="inspectionModel"
                                                        className="open-up-combo-box"
                                                        onChange={this.handleChangeComboDateWeek}
                                                        itemToString={(item) => item?.name || ''}
                                                        initialSelectedItem={selectedItemCombo.plannedWeek}
                                                        disabled={
                                                            listOfWeeks == null ||
                                                            listOfWeeks.length <= 0 ||
                                                            (this.state.isEditModal &&
                                                                !IsEditable(
                                                                    'Inspection',
                                                                    'Planning',
                                                                    user,
                                                                    this.getStatusId(this.state.inspectionModel.id),
                                                                    'All',
                                                                    this.getCanEditResource(this.state.inspectionModel.id)
                                                                ))
                                                        }
                                                        items={listOfWeeks || []}
                                                        invalid={validations.plannedWeek != null}
                                                    />
                                                ) : (
                                                    <DropdownSkeleton />
                                                )}
                                                {validations.plannedWeek}
                                            </FormGroup>
                                            {!this.state.inspectionModel?.isExt && (  // RITM0623664
                                                <FormGroup legendText="" className="bx--col-md-8">
                                                    <FormLabel className="some-class">Distribution List * (Personal Email adddress are not allowed)</FormLabel>

                                                    <EmailChips
                                                        key={this.state.emailChipsKey}
                                                        value={this.state?.inspectionModel?.distributionList || ''}
                                                        type="text"
                                                        title="&#9888; Do Not use Personal Accounts"
                                                        onChange={(value) =>
                                                            this.updateState('distributionList', value, 'inspectionModel')
                                                        }
                                                        invalid={validations.distributionList != null}
                                                        disabled={
                                                            this.state.isDisabled ||
                                                            (this.state.isEditModal &&
                                                                !IsEditable(
                                                                    'Inspection',
                                                                    'Planning',
                                                                    user,
                                                                    this.getStatusId(this.state.inspectionModel.id),
                                                                    'All',
                                                                    this.getCanEditResource(this.state.inspectionModel.id)
                                                                ))
                                                        }
                                                        masked={this.state.inspectionModel.maskedValue} //RITM0946005 - Anonimizzazione Modulo Inspection
                                                    />
                                                    {validations.distributionList}
                                                </FormGroup>
                                            )} {/*RITM0623664*/}
                                        </div>
                                    </Form>

                                    <div className="searchFormFooter">
                                        <Button
                                            className="button--max-width"
                                            kind="secondary"
                                            onClick={this.clearModalInspection}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            className="button--max-width"
                                            kind="primary"
                                            onClick={() => this.insertNewInspection()}
                                            disabled={
                                                this.state.isSubmitted ||
                                                (this.state.isEditModal &&
                                                    !IsEditable(
                                                        'Inspection',
                                                        'Planning',
                                                        user,
                                                        this.getStatusId(this.state.inspectionModel.id),
                                                        'All',
                                                        this.getCanEditResource(this.state.inspectionModel.id)
                                                    ))
                                            }
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </AppContext.Consumer>
        );
    }

    divFilter() {
        const filterItems = {
            idDivision: this.state.searchModel?.idDivision
                ? (this.state.divisions || []).find((el) => el.id === this.state.searchModel.idDivision)
                : [],
            idWorkSite: this.state.searchModel?.idWorkSite
                ? (this.state.appAllWorksites || []).find((el) => el.id === this.state.searchModel.idWorkSite)
                : [],
            idProject: this.state.searchModel?.idProject
                ? (this.state.appAllWorksitePrj || []).find((el) => el.idProject === this.state.searchModel.idProject)
                : [],
            idInspectionType: this.state.searchModel?.idInspectionType
                ? (this.state.inspecionType || []).find((el) => el.id === this.state.searchModel.idInspectionType)
                : [],
            idInspectionSection: this.state.searchModel?.idInspectionSection
                ? (this.state.inspectionSection || []).find((el) => el.id === this.state.searchModel.idInspectionSection)
                : [],
            idStatus: this.state.searchModel?.idStatus
                ? (this.state.status || []).find((el) => el.id === this.state.searchModel.idStatus)
                : [],
            idStatusReport: this.state.searchModel?.idStatusReport
                ? (this.state.status || []).find((el) => el.id === this.state.searchModel.idStatusReport)
                : [],
            //RITM0623664_InspectionEstemporanea
            onlyExt: this.state.searchModel.onlyExt,
            notExt: this.state.searchModel.notExt
        };
        const listWorksite = this.getWorksiteFiltered(this.state.searchModel?.idDivision);
        const listProject = this.getWorksitePrjFiltered(this.state.searchModel?.idWorkSite);
        return (
            // FILTRO

            <div style={{ display: this.state.isOpenSearchForm ? 'block' : 'none' }}>
                <div className="bx--modal bx--modal-tall is-visible">
                    <div className="bx--modal-container modal-container-custom">
                        <div className="modal-header">
                            <div className="bx--modal-header selection-items-list-costum">
                                <h3 className="bx--modal-header__heading"> {'FILTER INSPECTIONS'} </h3>{' '}
                            </div>
                            <Button
                                renderIcon={Close20}
                                iconDescription="Folder"
                                kind="ghost"
                                className="close-modal selection-items-list-costum-r"
                                onClick={this.toggleSearchForm}
                            />
                        </div>
                        <div class=" bx--modal-content margin-modal"> {/*RITM0999787*/}
                        <Form autoComplete="off" className="bx--row" onSubmit={this.handleClickSearch}>
                            <FormGroup legendText="" className="bx--col-md-4">
                                {/* RITM0945977 */}
                                {/* <FormLabel className="some-class">Division</FormLabel> */}
                                <FormLabel className="some-class">Business Line</FormLabel>

                                {this.state.isLoadingDivision ? (
                                    <DropdownSkeleton />
                                ) : (
                                    <ComboBox
                                        id="idSearchDivision"
                                        placeholder={
                                            this.state.searchModel?.idDivision == null ? filterItems.idDivision : 'All'
                                        }
                                        key="divisionsFilter"
                                        name="idDivision"
                                        alt="searchModel"
                                        onChange={this.handleChangeComboForFilter}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItem={
                                            this.state.searchModel?.idDivision ? filterItems.idDivision : 'All'
                                        }
                                        items={this.state.divisions}
                                        disabled={this.state?.divisions == null || this.state?.divisions?.length === 0}
                                    />
                                )}
                            </FormGroup>

                            <FormGroup legendText="" className="bx--col-md-4">
                                <FormLabel className="some-class">Worksite</FormLabel>

                                {this.state.isLoadingWorksite ? (
                                    <DropdownSkeleton />
                                ) : (
                                    <ComboBox
                                        id="idSearchWorkSite"
                                        placeholder={
                                            this.state.searchModel?.idWorkSite ? filterItems.idWorkSite : 'All'
                                        }
                                        key="worksitesFilter"
                                        name="idWorkSite"
                                        alt="searchModel"
                                        onChange={this.handleChangeComboForFilter}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItem={
                                            this.state.searchModel?.idWorkSite ? filterItems.idWorkSite : 'All'
                                        }
                                        items={listWorksite}
                                        disabled={listWorksite == null || listWorksite === 0}
                                    />
                                )}
                            </FormGroup>
                            <FormGroup legendText="" className="bx--col-md-4">
                                <FormLabel className="some-class">Project</FormLabel>
                                {this.state.isLoadingProject ? (
                                    <DropdownSkeleton />
                                ) : (
                                    <ComboBox
                                        id="idSearchProject"
                                        placeholder="All"
                                        key="projectsFilter"
                                        name="idProject"
                                        alt="searchModel"
                                        onChange={this.handleChangeComboForFilter}
                                        itemToString={(item) => (item ? item.project : '')}
                                        initialSelectedItem={
                                            this.state.searchModel?.idProject ? filterItems.idProject : 'All'
                                        }
                                        items={listProject}
                                        disabled={listProject == null || listProject?.length === 0}
                                    />
                                )}
                            </FormGroup>
                            <FormGroup legendText="" className="bx--col-md-4">
                                <FormLabel className="some-class">Inspection Section</FormLabel>
                                {this.state.isLoadingInspectionType ? (
                                    <DropdownSkeleton />
                                ) : (
                                    <ComboBox
                                        id="idSearchInspectionSection"
                                        key="inspectionSectionFilter"
                                        placeholder="Select"
                                        name="idInspectionSection"
                                        alt="searchModel"
                                        onChange={this.handleChangeComboForFilter}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItem={
                                            this.state.searchModel?.idInspectionSection
                                                ? filterItems.idInspectionSection
                                                : 'All'
                                        }
                                        items={this.state.inspectionSection.filter((e) => new Date(e.validUntil).getFullYear() >= this.state.searchModel.referenceYear)} //RITM1076870 - Inspection Section Filter Issue
                                    />
                                )}
                            </FormGroup>
                            <FormGroup legendText="" className="bx--col-md-4">
                                <FormLabel className="some-class">Inspection Type</FormLabel>
                                {this.state.isLoadingInspectionType ? (
                                    <DropdownSkeleton />
                                ) : (
                                    <ComboBox
                                        id="idSearchInspectionType"
                                        key="inspectiontypesFilter"
                                        placeholder="Select"
                                        name="idInspectionType"
                                        alt="searchModel"
                                        onChange={this.handleChangeComboForFilter}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItem={
                                            this.state.searchModel?.idInspectionType
                                                ? filterItems.idInspectionType
                                                : 'All'
                                        }
                                        items={this.state.inspecionType}
                                    />
                                )}
                            </FormGroup>
                            {/* //RITM0623664_InspectionEstemporanea  */}
                            <FormGroup legendText="" className="bx--col-md-4">
                                <FormLabel className="some-class">Inspection EXT</FormLabel>
                                <ComboBox
                                    id="idSearchInspectionType"
                                    key="inspectiontypesFilter"
                                    placeholder="Select"
                                    name="ext"
                                    alt="searchModel"
                                    onChange={this.handleChangeComboForFilter}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItem={filterItems.onlyExt ? typeEXT.find(el => el.name === "onlyExt") : filterItems.notExt ? typeEXT.find(el => el.name === "notExt") : null}
                                    items={typeEXT}
                                />
                            </FormGroup>
                            {/* //RITM0623664_InspectionEstemporanea  */}

                            <FormGroup legendText="" className="bx--col-md-4">
                                <FormLabel className="some-class">Status Plan</FormLabel>
                                {this.state.isLoadingStatus ? (
                                    <DropdownSkeleton />
                                ) : (
                                    <ComboBox
                                        id="idSearchStatus"
                                        placeholder="All"
                                        key="statusFilter"
                                        name="idStatus"
                                        alt="searchModel"
                                        onChange={this.handleChangeComboForFilter}
                                        itemToString={(item) => (item ? item.planningName : '')}
                                        initialSelectedItem={
                                            this.state.searchModel.idStatus ? filterItems.idStatus : 'All'
                                        }
                                        items={this.state.status.filter((e) => e.id !== 3)}
                                    />
                                )}
                            </FormGroup>

                            <FormGroup legendText="" className="bx--col-md-4">
                                <FormLabel className="some-class">Status Report</FormLabel>
                                {this.state.isLoadingStatus ? (
                                    <DropdownSkeleton />
                                ) : (
                                    <ComboBox
                                        id="idSearchStatusReport"
                                        placeholder="All"
                                        key="statusReportFilter"
                                        name="idStatusReport"
                                        alt="searchModel"
                                        onChange={this.handleChangeComboForFilter}
                                        itemToString={(item) => (item ? item.reportingName : '')}
                                        initialSelectedItem={
                                            this.state.searchModel.idStatusReport ? filterItems.idStatusReport : 'All'
                                        }
                                        items={this.state.status.filter((e) => e.id !== 3)}  /*RUOLI_APPROVATIVI_DEV_255_RITM0565449*/
                                    />
                                )}
                            </FormGroup>

                            <FormGroup legendText="" className="bx--col-md-4">
                                <FormLabel className="some-class">Code Inspection</FormLabel>
                                <TextInput
                                    id="txt-name"
                                    name="inspectionCode"
                                    placeholder="Input Code"
                                    alt="searchModel"
                                    onChange={this.handleChangeModel}
                                    value={this.state.searchModel.inspectionCode || ''}
                                    type="text"
                                    hideLabel
                                    labelText=""
                                />
                            </FormGroup>
                            <FormGroup legendText="" className="bx--col-md-4">
                                <FormLabel className="some-class">Email Compiler</FormLabel>
                                <TextInput
                                    id="txt-name"
                                    name="emailCompiler"
                                    placeholder="Input Email Compiler"
                                    alt="searchModel"
                                    onChange={this.handleChangeModel}
                                    value={this.state.searchModel.emailCompiler || ''}
                                    type="text"
                                    hideLabel
                                    labelText=""
                                />
                            </FormGroup>
                            <FormGroup legendText="" className="bx--col-md-4">
                                <FormLabel className="some-class">Email Data Approver</FormLabel>
                                <TextInput
                                    id="txt-name"
                                    name="emailDataApprover"
                                    placeholder="Input Email Data Approver"
                                    alt="searchModel"
                                    onChange={this.handleChangeModel}
                                    value={this.state.searchModel.emailDataApprover || ''}
                                    type="text"
                                    hideLabel
                                    labelText=""
                                />
                            </FormGroup>
                            <FormGroup legendText="" className="bx--col-md-4">
                                <FormLabel className="some-class">Email Consolidator</FormLabel>
                                <TextInput
                                    id="txt-name"
                                    name="emailDivisionManager"
                                    placeholder="Input Consolidator"
                                    alt="searchModel"
                                    onChange={this.handleChangeModel}
                                    value={this.state.searchModel.emailDivisionManager || ''}
                                    type="text"
                                    hideLabel
                                    labelText=""
                                />
                            </FormGroup>
                        </Form>
                        </div> {/*RITM0999787*/}
                        <div className="searchFormFooter">
                            <Button
                                className="button--max-width"
                                size="small"
                                kind="secondary"
                                onClick={this.handleClickCancelSearch}
                            >
                                Cancel
                            </Button>
                            <Button className="button--max-width" size="small" onClick={this.handleClickSearch}>
                                Search
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

   //RITM1037347 
   toggleReasonModal = () => {       
    this.setState((oldState) => ({
        reason: null,
        isReasonModalOpen: !oldState.isReasonModalOpen,
    }));
};
divModalReopenReason() {     
  return (
  <div className="bx--modal bx--modal-tall is-visible">
      <div className="bx--modal-container modal-overflow-visible">
          <div className="bx--modal-header">
              <h3 className="bx--modal-header__heading"> REASON TO REOPEN </h3>{' '}
          </div>
          <br></br>
          <div className="bx--row">
              <div className="bx--col-lg-12 bx--col-md-6">
                  {/* below needs change */}<FormGroup
                      legendText="REASON TO REOPEN the INSPECTION PLAN* " >
                      <ComboBox
                          id="idReason"
                          placeholder="Select"
                          name="idReason"
                          alt="inspectionModel"
                          onChange={this.handleChangeCombo}                              
                        itemToString={(item) => (item ? item.name : '')}
                        initialSelectedItem={"Select"}                                
                        items={this.state.xReasons.filter((x) => x.code == 'Inspectionplan')}
                     />
                      
                  </FormGroup>
              </div>

          </div>
          <div className="searchFormFooter mt-20">
              <Button
                  className="button--max-width"
                  kind="secondary"
                  onClick={this.toggleReasonModal}
              >
                  Cancel
              </Button>
              <Button
                  className="button--max-width"
                  kind="primary"
                  onClick={this.toggleWarningReOpenModal}
                  disabled={this.state.reason == 'Select' ||this.state.reason == null}
              >
                  Save
              </Button>
          </div>
      </div>
  </div>
  );
}
toggleWarningReOpenModal = () => {    
  this.setState((prevState) => ({
      isWarningReOpenModalOpen: !prevState.isWarningReOpenModalOpen,
  }));      
  
};
handleConfirmReOpenSubmit = () => {
  this.setState(
      {
          isWarningReOpenModalOpen: false,
      },
      this.toggleReasonModal(),
      this.ReopenInspectionData()
      // () => this.submitReport(true)
  );
};
ReopenInspectionData = () => {
  api
      .put(`inspection/reopenplan/${this.state.inspectionModel.id}/${this.state.reason}`)
      .then((response) => {
          if (response.status === 200) {
              this.setState({
                  isWarningReOpenModalOpen: false,
                  isOpenModalInspection:false,
              });
              //this.onCloseConfirm();
              showNotification.success(
                  `${entitiesLabels.SUCCESS}`,
                  getSuccess(entitiesLabels.REPORT, apioperation.PUT)
              );
              this.getInspections();
          } else {
              showNotification.error();
          }
      })
      .catch((error) => {
          showNotification.error(
              `${entitiesLabels.ERROR}`,
              getError(error, entitiesLabels.REPORT, apioperation.PUT)
          );
       });
};

 // RITM1037347 end
    // /HISOTRY
    showButtonHistory = () => (
        <Button kind="ghost" renderIcon={Information16} onClick={() => this.openModalHistory()}>
            History
        </Button>
    );

    openModalHistory = () => {
        this.setState({ isHistoryModalOpen: true });
    };

    closeModalHistory = () => {
        this.setState({ isHistoryModalOpen: false });
    };

    // WF
    batchActionClick(
        actionKey,
        actionName,
        approverRole,
        withApprover,
        approvalNotesRequired,
        selectedRows
    ) {
        const inspection = this.state.inspections.find((i) => i.id === selectedRows[0].id);
        const idWorksite =
            actionName === 'Submit'
                ? inspection.idWorkSite
                : null; //RITM1064131
        const idDivision =
            actionName === 'Approve'
                ? inspection.idDivision
                : null; //RITM1064131

        this.setState({
            approvalModalAction: actionName,
            isApprovalModalOpen: true,
            isLoadingApproverOptions: true,
            withApprover,
            selectedData: selectedRows,
            approverRole,
            approvalEndpoint: actionKey,
            approvalNotesRequired,
        });

        if (withApprover) this.getUsersInRole(approverRole, 'Inspection', idWorksite, idDivision); //RITM1064131
    }

    isRowOfExtInspection = (incidentId) => {
        const inspection = this.state.inspections.find((i) => i.id === incidentId);
        return inspection?.isExt ?? false
    }

    IsRowSelectable(row, selectedRows, user) {
        const entity = this.state.inspections.find((i) => i.id === row.id);

        if (entity.idStatusReport === 4) return false;

        const canSelectReporting =
            CanExecuteAction(
                'Inspection',
                'Reporting',
                user,
                entity.idStatusReport,
                'Create',
                this.getCompilerRow(entity)
            ) ||
            //RITM1227369
            CanExecuteAction(
                'Inspection',
                'Reporting',
                user,
                entity.idStatusReport,
                'Create',
                this.getCompilerByWorksiteRow(entity, user)
            ) ||
            //End
            CanExecuteAction(
                'Inspection',
                'Reporting',
                user,
                entity.idStatusReport,
                'Submit',
                entity && entity.inspectionReport
            ) ||
            CanExecuteAction(
                'Inspection',
                'Reporting',
                user,
                entity.idStatusReport,
                'Approve',
                entity && entity.inspectionReport
            ) ||
            CanExecuteAction(
                'Inspection',
                'Reporting',
                user,
                entity.idStatusReport,
                'Consolidate',
                entity && entity.inspectionReport
            ) ||
            CanExecuteAction(
                'Inspection',
                'Reporting',
                user,
                entity.idStatusReport,
                'Reject',
                entity && entity.inspectionReport
            ) ||
            CanExecuteAction(
                'Inspection',
                'Reporting',
                user,
                entity.idStatusReport,
                'RejectConsolidate',
                entity && entity.inspectionReport
            );
        const canSelect =
            CanExecuteAction('Inspection', 'Planning', user, entity.idStatus, 'Submit', entity) ||
            CanExecuteAction('Inspection', 'Planning', user, entity.idStatus, 'Approve', entity) ||
            CanExecuteAction('Inspection', 'Planning', user, entity.idStatus, 'Reject', entity) ||
            CanExecuteAction('Inspection', 'Planning', user, entity.idStatus, 'Delete', entity)
            //RITM0623664_InspectionEstemporanea
            || CanExecuteAction('Inspection', 'PlanningExt', user, entity.idStatus, 'AssignExtReport', entity)
        //---FINE RITM0623664

        if (selectedRows.length === 0) {
            if (entity?.inspectionReport || entity.idStatus >= 4) return canSelectReporting;
            return canSelect;
        }

        if (selectedRows.length > 0) {
            const selectableInspection = this.state.inspections.find((i) => i.id === selectedRows[0].id);
            const selectableState = selectableInspection.idStatus;
            const selectableStateReporting = selectableInspection.idStatusReport;
            const selectableDivision = selectableInspection.idDivision;
            const selectableWorksite = selectableInspection.idWorkSite;
            //RITM0623664_InspectionEstemporanea
            if ((selectableInspection.isExt ?? false) !== (entity.isExt ?? false)) return false
            //--FINE RITM0623664

            const process =
                (selectableStateReporting != null && selectableStateReporting > 0) ||
                    (selectableState != null && selectableState >= 4)
                    ? 'REPORTING'
                    : 'PLANNING';


            if (process === 'REPORTING') {
                if (
                    entity.idStatusReport === selectableStateReporting &&
                    (entity.idStatusReport === 1
                        ? entity.idWorkSite === selectableWorksite
                        : entity.idDivision === selectableDivision)
                ) {
                    return canSelectReporting;
                }
            }

            if (process === 'PLANNING') {
                if (entity.idStatus === selectableState && entity.idWorkSite === selectableWorksite) {
                    return canSelect;
                }
            }

            return false;
        }
    }

    handleApproverSelect = (selectedItem) => {
        this.setState({ approver: selectedItem });
    };

    handleCloseApprovalModal = () => {
        this.setState({ isApprovalModalOpen: false, approver: null });
    };

    handleApprovalNotesChange = (e) => {
        this.setState({ approvalNotes: e.target.value });
    };

    handleConfirmApprovalModal = () => {
        const apiEndpoint = this.state.approvalEndpoint;

        const data = {
            ids: this.state.selectedData.map((r) => r.id),
            owner: this.state.approver,
            workflowNotes: this.state.approvalNotes,
        };

        this.setState({
            isLoadingWFOperation: true,
        });
        api
            .put(`/inspection/${apiEndpoint}`, data, '')
            .then((response) => {
                if (response.status === 200) {
                    showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.INSPECTION, apioperation.PUT));
                    this.setState({
                        isLoadingWFOperation: false,
                        isApprovalModalOpen: false,
                        isLoading: true,
                        inspection: [],
                        searchModel: {
                            ...this.searchProp(),
                            needToChange: true,
                        },
                    },
                    () => {
                        this.getInspections()
                     } 
                ); //RITM1258665
                    
                } else {
                    showNotification.error();
                    this.setState({
                        isLoadingWFOperation: false,
                    });
                }
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, apioperation.PUT));
                this.setState({
                    isLoadingWFOperation: false,
                });
            })
            .finally(() => {
                this.setState({
                    approver: null,
                });
            });
    };

    getInspection = (selectedRows) => {
        if (selectedRows && selectedRows.length > 0) {
            return this.state.inspections.find((el) => el.id === selectedRows[0].id);
        }
        return null;
    };

    getCompilerRow = (entity) => {
        if (entity != null) {
            const ins = this.state.inspections.find((el) => el.id === entity.id);
            // return ins && ins.inspectors && ins.inspectors[0]
            // ? { idCompiler: ins.inspectors[0].id }
            // : null;
            //RITM0628222
            return { idCompiler: ins?.idCompiler }
        }
        return null;
    };

    getCompiler = (selectedRows) => {
       if (selectedRows && selectedRows.length > 0) {
            const ins = this.state.inspections.find((el) => el.id === selectedRows[0].id);
            // return ins && ins.inspectors && ins.inspectors[0]
            // ? { idCompiler: ins.inspectors[0].id }
            // : null;
            //RITM0628222
            return { idCompiler: ins?.idCompiler }
        }
        return null;
    };

    //RITM1227369
    getCompilerByWorksiteRow = (entity, user) => {
        if (entity != null) {
            const ins = this.state.inspections.find((el) => el.id === entity.id);
            const idUser = this.state.allInspectors.find((el) => el.id === user.id)?.userRoles?.filter((item) => item.idWorksite === ins.idWorkSite)?.map((element) => element?.idUser);
            return { idCompiler: idUser ? idUser[0] : null }
        }
        return null;
    };
    getCompilerByWorksite = (selectedRows, user) => {
        if (selectedRows && selectedRows.length > 0) {
            const ins = this.state.inspections.find((el) => el.id === selectedRows[0].id);
            const idUser = this.state.allInspectors.find((el) => el.id === user.id)?.userRoles?.filter((item) => item.idWorksite === ins.idWorkSite)?.map((element) => element?.idUser);
            return { idCompiler: idUser ? idUser[0] : null }
        }
        return null;
    };
    getAllInspectionCompilers() {
        this.setState({
            isLoadingInspectors: true,
        });
        this.setState({
            allInspectors: [],
        });
        api
            .getAll('inspection/allinspectors')
            .then((response) => {
                this.setState({
                    allInspectors: response.data,
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoadingInspectors: false,
                });
            });
    }
    //End


    getInspectionReport = (selectedRows) => {
        if (selectedRows && selectedRows.length > 0) {
            const ins = this.state.inspections.find((el) => el.id === selectedRows[0].id);
            return ins && ins.inspectionReport;
        }
        return null;
    };

    getStatusId = (idRow) => {
        const r = this.state.inspections.find((el) => el.id === idRow);
        return r && r.idStatus;
    };

    getReportStatusId = (idRow) => {
        const r = this.state.inspections.find((el) => el.id === idRow);

        return r && r.inspectionReport && r.inspectionReport.idStatus;
    };

    getCanEditResource = (idRow) => {
        const r = this.state.inspections.find((el) => el.id === idRow);
        return r;
    };

    render() {
        const inspectionHeader = [
            { key: 'inspectionCode', header: 'Code' },
            //RITM0945977
            // { key: 'division', header: 'Division' },
            { key: 'division', header: 'Business Line' },
            { key: 'workSite', header: 'WorkSite' },
            { key: 'inspectionSection', header: 'Inspection Section' },
            { key: 'inspectionType', header: 'Inspection Type' },
            { key: 'plannedWeek', header: 'Planned Week' },
            { key: 'status', header: 'Status Plan', type: 'status' },
            { key: 'statusReport', header: 'Status Report', type: 'status' },
        ];
        const paginationProps = () => ({
            page: this.state.currentPage || 1,
            totalItems: this.state.rowCount || 0,
            pageSize: this.state.pageSize || 10,
            pageSizes: [10, 20, 30, 40, 50],
            onChange: this.handleChangePaging,
        });

        const rows = [];

        const getWeekPeriod = (week, year) => {
            //INC1534463 - Inspection Week Span Fix
            //const x = moment(year.toString()).add(week, 'weeks');
            const x = moment(year.toString()).add(week - 1, 'weeks');
            //End
            return `Week ${week} :${x.startOf('isoWeek').format('DD/MM/YYYY')} - ${x
                .endOf('isoWeek')
                .format('DD/MM/YYYY')}`;
        };

        if (this.state.inspections) {
            this.state.inspections.forEach((item) => {
                const weeekPeriod = getWeekPeriod(item.plannedWeek, item.referenceYear);
                const inspectionSection = this.state.inspectionSection.filter(x => x.id === item.inspectionType.idInspectionSection);
                rows.push({
                    id: item.id,
                    inspectionCode: item.inspectionCode,
                    division: item.division,
                    workSite: item.workSite,
                    inspectionType: item.inspectionType.name,
                    inspectionSection: inspectionSection[0]?.name,
                    plannedWeek: weeekPeriod,
                    status: item.status,
                    statusReport: item.statusReport,
                });
            });
        }
        return (
            <AppContext.Consumer>
                {({ user }) => (
                    <>
                        <PageBreadCrumb
                            linkTo="/modules"
                            linkText="Modules"
                            titleLeft="Inspection Management"
                        />
                        {this.state.isLoadingNotificationFile ? <Loading /> : ''}
                        <div className=" mainContainer ">
                          
                            <div className="bx--grid content full-width mainContainer ">
                                <div className="header-custom-toolbar">
                                    <TableToolbar>
                                        <Search
                                            readOnly
                                            light
                                            className="search cursor-pointer hiddenSearch"
                                            labelText="Search"
                                            placeHolderText="Search"
                                            id="search-1"
                                            onClick={this.toggleSearchForm}
                                        />
                                        <Button
                                            onClick={this.toogleCalendar}
                                            className="buttonPaddingIcon"
                                            renderIcon={Calendar16}
                                            iconDescription="Filter"
                                        />
                                        <Button
                                            onClick={this.toggleSearchForm}
                                            className="buttonPaddingIcon"
                                            renderIcon={Data16}
                                            iconDescription="Filter"
                                        />
                                        {/* //RITM0623664_InspectionEstemporanea  */}
                                        <Button
                                            onClick={() => this.showDivModaleInspection(true)}
                                            renderIcon={Add20}
                                            disabled={!(IsInRole(user, 'Administrator') || IsInRole(user, 'Compiler') || IsInRole(user, 'Data Approver'))} //RITM1064131
                                        >
                                            New Inspection Report
                                        </Button>
                                        {/* //RITM0623664_InspectionEstemporanea  */}

                                        <Button
                                            onClick={() => this.showDivModaleInspection(false)}
                                            renderIcon={Add20}
                                            disabled={!(IsInRole(user, 'Administrator') || IsInRole(user, 'Compiler') || IsInRole(user, 'Data Approver'))} //RITM1064131
                                        >
                                            Plan New Inspection
                                        </Button>
                                    </TableToolbar>
                                </div>
                                <h4 className="description-page bx--col-lg-8">
                                    Current year
                                    <Dropdown
                                        id="current"
                                        label=""
                                        items={this.state.years}
                                        onChange={this.onYearChange}
                                        initialSelectedItem={this.year.toString()}
                                        selectedItem={this.state.searchModel.referenceYear.toString()}
                                        itemToString={(item) => item || ''}
                                        type="inline"
                                    />
                                </h4>
                               
                                {this.state.spinner ? <Loading /> : ''}
                                {this.divFilter()}
                                {this.modalNewInspection(user)}
                                {/* CALENDAR */}
                                <div style={{ display: this.state.isOpenCalendar ? 'block' : 'none' }}>
                                    {this.state.isLoadingCalendar ? (
                                        <div className="layout-skeleton-calendar">
                                            <Loading withOverlay />
                                            <table className="table-layout-custom">
                                                <tbody>
                                                    <CalendarSkeleton />
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <table className="table-layout-custom">
                                            <tbody>
                                                <InspectionMonthHeader
                                                    calendar={this.state.calendar}
                                                    onSelectWeek={this.filterByWeek}
                                                    onSelectMonth={this.filterByMonths}
                                                    monthsSelected={this.state.isBack ? this.state.monthsSelected : []}
                                                    weeksSelected={this.state.isBack ? this.state.weeksSelected : []}
                                                />
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                                <WFActionModal
                                    show={this.state.isApprovalModalOpen}
                                    title={`${this.state.approvalModalAction} Inspections`}
                                    action={this.state.approvalModalAction}
                                    withApprover={this.state.withApprover}
                                    approver={this.state.approver}
                                    approverRole={this.state.approverRole}
                                    approverOptions={this.state.approvers}
                                    isLoadingOperation={this.state.isLoadingWFOperation}
                                    onApproverSelect={this.handleApproverSelect}
                                    isLoadingOptions={this.state.isLoadingApproverOptions}
                                    onCancel={this.handleCloseApprovalModal}
                                    onConfirm={this.handleConfirmApprovalModal}
                                    onApprovalNotesChange={this.handleApprovalNotesChange}
                                    approvalNotes={this.state.approvalNotes}
                                    approvalNotesRequired={this.state.approvalNotesRequired}
                                    validationMessages={this.state.approvalValidationMessages}
                                    user={user} //RITM1064131
                                />
                                <DataTable
                                    rows={rows}
                                    headers={inspectionHeader}
                                    useZebraStyles
                                    size="compact"
                                    render={({
                                        rows,
                                        headers,
                                        getHeaderProps,
                                        getRowProps,
                                        getSelectionProps,
                                        selectedRows,
                                        getBatchActionProps,
                                    }) => (
                                        <TableContainer className="bx--grid--full-width" title="">
                                            {selectedRows.length > 0 ? (
                                                <TableToolbar>
                                                    <TableToolbarContent>
                                                        <Online>
                                                            <TableBatchActions {...getBatchActionProps()}>
                                                                {CanExecuteAction(
                                                                    'Inspection',
                                                                    this.isRowOfExtInspection(selectedRows[0].id) ? "PlanningExt" : 'Planning',
                                                                    user,
                                                                    selectedRows.length > 0
                                                                        ? this.getStatusId(selectedRows[0].id)
                                                                        : null,
                                                                    'Submit',
                                                                    this.getInspection(selectedRows)
                                                                ) ? (
                                                                    <TableBatchAction
                                                                        renderIcon={Send16}
                                                                        onClick={() =>
                                                                            this.batchActionClick(
                                                                                'Submit',
                                                                                'Submit',
                                                                                'Data Approver',
                                                                                true,
                                                                                false,
                                                                                selectedRows
                                                                            )
                                                                        }
                                                                    >
                                                                        Submit Plan
                                                                    </TableBatchAction>
                                                                ) : null}
                                                                {CanExecuteAction(
                                                                    'Inspection',
                                                                    'Planning',
                                                                    user,
                                                                    selectedRows.length > 0
                                                                        ? this.getStatusId(selectedRows[0].id)
                                                                        : null,
                                                                    'Approve',
                                                                    this.getInspection(selectedRows)
                                                                ) ? (
                                                                    <TableBatchAction
                                                                        renderIcon={CheckmarkOutline16}
                                                                        onClick={() =>
                                                                            this.batchActionClick(
                                                                                'Approve',
                                                                                'Approve',
                                                                                null,
                                                                                false,
                                                                                false,
                                                                                selectedRows
                                                                            )
                                                                        }
                                                                    >
                                                                        Approve Plan
                                                                    </TableBatchAction>
                                                                ) : null}
                                                                {CanExecuteAction(
                                                                    'Inspection',
                                                                    'Planning',
                                                                    user,
                                                                    selectedRows.length > 0
                                                                        ? this.getStatusId(selectedRows[0].id)
                                                                        : null,
                                                                    'Reject',
                                                                    this.getInspection(selectedRows)
                                                                ) ? (
                                                                    <TableBatchAction
                                                                        renderIcon={Error16}
                                                                        onClick={() =>
                                                                            this.batchActionClick(
                                                                                'Reject',
                                                                                'Reject',
                                                                                null,
                                                                                false,
                                                                                true,
                                                                                selectedRows
                                                                            )
                                                                        }
                                                                    >
                                                                        Reject Plan
                                                                    </TableBatchAction>
                                                                ) : null}
                                                                {/* //RITM0623664_InspectionEstemporanea */}
                                                                {CanExecuteAction(
                                                                    'Inspection',
                                                                    this.isRowOfExtInspection(selectedRows[0].id) ? "PlanningExt" : 'Planning',
                                                                    user,
                                                                    selectedRows.length > 0
                                                                        ? this.getStatusId(selectedRows[0].id)
                                                                        : null,
                                                                    'AssignExtReport',
                                                                    this.getInspection(selectedRows)
                                                                ) ? (
                                                                    <TableBatchAction
                                                                        renderIcon={Task16}
                                                                        onClick={() =>
                                                                            this.batchActionClick(
                                                                                'AssignExtReport',
                                                                                'Assign Ext Report',
                                                                                null,
                                                                                false,
                                                                                false,
                                                                                selectedRows
                                                                            )
                                                                        }
                                                                    >
                                                                        Assign Ext Report
                                                                    </TableBatchAction>
                                                                ) : null}
                                                                {/* FINE //RITM0623664_InspectionEstemporanea */}
                                                                {CanExecuteAction(
                                                                    'Inspection',
                                                                    'Planning',
                                                                    user,
                                                                    selectedRows.length > 0
                                                                        ? this.getStatusId(selectedRows[0].id)
                                                                        : null,
                                                                    'Delete',
                                                                    this.getInspection(selectedRows)
                                                                ) ? (
                                                                    <TableBatchAction
                                                                        renderIcon={Delete16}
                                                                        onClick={() =>
                                                                            this.batchActionClick(
                                                                                'Delete',
                                                                                'Delete',
                                                                                null,
                                                                                false,
                                                                                false,
                                                                                selectedRows
                                                                            )
                                                                        }
                                                                    >
                                                                        Delete Plan
                                                                    </TableBatchAction>
                                                                ) : null}
                                                                {selectedRows.length > 0 &&
                                                                    this.getStatusId(selectedRows[0].id) === 4 && (
                                                                        // DEV 156
                                                                        //RITM1227369
                                                                        <>{(CanExecuteAction(
                                                                            'Inspection',
                                                                            'Reporting',
                                                                            user,
                                                                            selectedRows.length > 0
                                                                                ? this.getReportStatusId(selectedRows[0].id)
                                                                                : null,
                                                                            'Create',
                                                                            this.getCompiler(selectedRows)) ||
                                                                            CanExecuteAction(
                                                                                'Inspection',
                                                                                'Reporting',
                                                                                user,
                                                                                selectedRows.length > 0
                                                                                    ? this.getReportStatusId(selectedRows[0].id)
                                                                                    : null,
                                                                                'Create',
                                                                                this.getCompilerByWorksite(selectedRows, user)
                                                                            //End
                                                                        )) ? (
                                                                            <AsyncFilterContainer
                                                                                key={'asyncFilterContainerForAssignReport' + this.state.inspectionModel?.inspectionSection?.id}
                                                                                check={() => this.handleApproveReportCheck(user)}
                                                                                onMount={async () => {
                                                                                    const inspection = await this.getInspection(selectedRows);
                                                                                    this.getInspectors(inspection.idWorkSite);
                                                                                }}
                                                                                placeholder={
                                                                                    <ButtonSkeleton size="small" />
                                                                                }
                                                                            >
                                                                                <TableBatchAction
                                                                                    renderIcon={Task16}
                                                                                    onClick={() => {
                                                                                        this.batchActionClick('newreport', 'Assign', null, false, false, selectedRows);
                                                                                    }}
                                                                                >
                                                                                    Assign Report
                                                                                </TableBatchAction>
                                                                            </AsyncFilterContainer>
                                                                        ) : null
                                                                        }
                                                                            {CanExecuteAction(
                                                                                'Inspection',
                                                                                'Reporting',
                                                                                user,
                                                                                selectedRows.length > 0
                                                                                    ? this.getReportStatusId(selectedRows[0].id)
                                                                                    : null,
                                                                                'Submit',
                                                                                this.getInspectionReport(selectedRows)
                                                                            ) ? (
                                                                                <TableBatchAction
                                                                                    renderIcon={Send16}
                                                                                    onClick={() =>
                                                                                        this.batchActionClick(
                                                                                            'submitreport',
                                                                                            'Submit',
                                                                                            'Data Approver',
                                                                                            true,
                                                                                            false,
                                                                                            selectedRows
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Submit Report
                                                                                </TableBatchAction>
                                                                            ) : null}
                                                                            {CanExecuteAction(
                                                                                'Inspection',
                                                                                'Reporting',
                                                                                user,
                                                                                selectedRows.length > 0
                                                                                    ? this.getReportStatusId(selectedRows[0].id)
                                                                                    : null,
                                                                                'Approve',
                                                                                this.getInspectionReport(selectedRows)
                                                                            ) ? (
                                                                                <TableBatchAction
                                                                                    renderIcon={CheckmarkOutline16}
                                                                                    onClick={() =>
                                                                                        this.batchActionClick(
                                                                                            'approvereport',
                                                                                            'Approve',
                                                                                            null, /*RUOLI_APPROVATIVI_DEV_255_RITM0565449*/
                                                                                            false, /*RUOLI_APPROVATIVI_DEV_255_RITM0565449*/
                                                                                            false,
                                                                                            selectedRows
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Approve Report
                                                                                </TableBatchAction>
                                                                            ) : null}

                                                                            {CanExecuteAction(
                                                                                'Inspection',
                                                                                'Reporting',
                                                                                user,
                                                                                selectedRows.length > 0
                                                                                    ? this.getReportStatusId(selectedRows[0].id)
                                                                                    : null,
                                                                                'Consolidate',
                                                                                this.getInspectionReport(selectedRows)
                                                                            ) ? (
                                                                                <TableBatchAction
                                                                                    renderIcon={CheckmarkOutline16}
                                                                                    onClick={() =>
                                                                                        this.batchActionClick(
                                                                                            'consolidatereport',
                                                                                            'Consolidate',
                                                                                            null,
                                                                                            false,
                                                                                            false,
                                                                                            selectedRows
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Consolidate Report
                                                                                </TableBatchAction>
                                                                            ) : null}

                                                                            {CanExecuteAction(
                                                                                'Inspection',
                                                                                'Reporting',
                                                                                user,
                                                                                selectedRows.length > 0
                                                                                    ? this.getReportStatusId(selectedRows[0].id)
                                                                                    : null,
                                                                                'Reject',
                                                                                this.getInspectionReport(selectedRows)
                                                                            ) ? (
                                                                                <TableBatchAction
                                                                                    renderIcon={Error16}
                                                                                    onClick={() =>
                                                                                        this.batchActionClick(
                                                                                            'rejectreport',
                                                                                            'Reject',
                                                                                            null,
                                                                                            false,
                                                                                            true,
                                                                                            selectedRows
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Reject Report
                                                                                </TableBatchAction>
                                                                            ) : null}

                                                                            {CanExecuteAction(
                                                                                'Inspection',
                                                                                'Reporting',
                                                                                user,
                                                                                selectedRows.length > 0
                                                                                    ? this.getReportStatusId(selectedRows[0].id)
                                                                                    : null,
                                                                                'RejectConsolidate',
                                                                                this.getInspectionReport(selectedRows)
                                                                            ) ? (
                                                                                <TableBatchAction
                                                                                    renderIcon={Error16}
                                                                                    onClick={() =>
                                                                                        this.batchActionClick(
                                                                                            'rejectconsolidatereport',
                                                                                            'Reject',
                                                                                            null,
                                                                                            false,
                                                                                            true,
                                                                                            selectedRows
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Reject Report
                                                                                </TableBatchAction>
                                                                            ) : null}
                                                                        </>
                                                                    )}
                                                            </TableBatchActions>
                                                        </Online>
                                                    </TableToolbarContent>
                                                </TableToolbar>
                                            ) : (
                                                ''
                                            )}
                                            {this.state.isLoadingList ? (
                                                <DataTableSkeleton
                                                    headers={[]}
                                                    rowCount={3}
                                                    zebra={false}
                                                    compact={false}
                                                />
                                            ) : (
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            {/* <TableSelectAll {...getSelectionProps()} /> */}
                                                            <TableHeader className="align-center" />

                                                            {headers.map((header) => (
                                                                <TableHeader
                                                                    className={header.type === 'bool' ? 'align-center' : ''}
                                                                    {...getHeaderProps({ header })}
                                                                >
                                                                    {header.header}
                                                                </TableHeader>
                                                            ))}
                                                            <TableHeader className="align-center">Actions</TableHeader>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {rows == null || rows.length === 0 ? (
                                                            <NoRecordsPlaceholder colSpan={headers.length + 2} />
                                                        ) : (
                                                            rows.map((row) => (
                                                                <TableRow {...getRowProps({ row })}>
                                                                    <Online>
                                                                        {this.IsRowSelectable(row, selectedRows, user) ? (
                                                                            <TableSelectRow {...getSelectionProps({ row })} />
                                                                        ) : (
                                                                            <TableCell
                                                                                key={`empty${row.id}`}
                                                                                className="tableActions align-center"
                                                                            />
                                                                        )}
                                                                    </Online>
                                                                    <Offline>
                                                                        <TableSelectRow {...getSelectionProps({ row })} disabled />
                                                                    </Offline>
                                                                    {row.cells.map((cell) => (
                                                                        <RenderDataTableCell
                                                                            key={cell.id}
                                                                            cell={cell}
                                                                            header={headers.find((x) => x.key === cell.info.header)}
                                                                            //RITM0623664_InspectionEstemporanea
                                                                            isExt={this.isRowOfExtInspection(row.id)}
                                                                        />
                                                                    ))}

                                                                    <TableCell
                                                                        key={`action-${row.id}`}
                                                                        className="tableActions align-center"
                                                                    >
                                                                        <div>
                                                                            <Online>
                                                                                {this.getReportStatusId(row.id) && !this.isRowOfExtInspection(row.id) && (
                                                                                    <FileDownLoadButton
                                                                                        onError={(error) => {
                                                                                            showNotification.error(`${entitiesLabels.ERROR}`,
                                                                                                getError(
                                                                                                    error,
                                                                                                    entitiesLabels.INSPECTION_NOTIFICATION,
                                                                                                    apioperation.DOWNLOAD
                                                                                                )
                                                                                            );
                                                                                        }}
                                                                                        size="small"
                                                                                        renderIcon={DocumentExport16}
                                                                                        iconDescription="Download Notification"
                                                                                        className="bx--export-form"
                                                                                        title="Download Notification"
                                                                                        kind="ghost"
                                                                                        apiUrl={`/inspection/${row.id}/export`}
                                                                                        //fileName={`Inspection_Notification_${row.inspectionCode}.pdf`}
                                                                                        fileName={this.getInspectionCode(row.id)}
                                                                                        onDownLoadStart={() => {
                                                                                            this.setState({
                                                                                                isLoadingNotificationFile: true,
                                                                                            });
                                                                                        }}
                                                                                        onDownLoadEnd={() => {
                                                                                            this.setState({
                                                                                                isLoadingNotificationFile: false,
                                                                                            });
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                                {this.getReportStatusId(row.id) && (
                                                                                    <FileDownLoadButton
                                                                                        onError={(error) => {
                                                                                            showNotification.error(`${entitiesLabels.ERROR}`,
                                                                                                getError(
                                                                                                    error,
                                                                                                    entitiesLabels.INCIDENT_NOTIFICATION,
                                                                                                    apioperation.DOWNLOAD
                                                                                                )
                                                                                            );
                                                                                        }}
                                                                                        size="small"
                                                                                        className=" bx--export-tab-form"
                                                                                        renderIcon={DocumentExport16}
                                                                                        iconDescription="Download Report"
                                                                                        title="Download Report"
                                                                                        kind="ghost"
                                                                                        apiUrl={`/inspection/${row.id}/exportreport`}
                                                                                        //fileName={`Inspection_Report_${row.inspectionCode}.pdf`}
                                                                                        fileName={this.getInspectionReportCode(row.id)}
                                                                                        onDownLoadStart={() => {
                                                                                            this.setState({
                                                                                                isLoadingNotificationFile: true,
                                                                                            });
                                                                                        }}
                                                                                        onDownLoadEnd={() => {
                                                                                            this.setState({
                                                                                                isLoadingNotificationFile: false,
                                                                                            });
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </Online>
                                                                            {!this.getReportStatusId(row.id) && (
                                                                                <Button
                                                                                    size="small"
                                                                                    renderIcon={Edit16}
                                                                                    iconDescription="Folder"
                                                                                    kind="ghost"
                                                                                    onClick={() => this.getInspectionEdit(row.id)}
                                                                                />
                                                                            )}
                                                                            {this.getReportStatusId(row.id) && (
                                                                                <Link to={`/inspection/${row.id}`}>
                                                                                    <Button
                                                                                        size="small"
                                                                                        renderIcon={Report16}
                                                                                        title="View Inspection Report"
                                                                                        iconDescription="View Inspection Report"
                                                                                        kind="ghost"
                                                                                    />
                                                                                </Link>
                                                                            )}
                                                                        </div>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            )}
                                        </TableContainer>
                                    )}
                                />
                                <div className="footer-pagination">
                                    <Pagination {...paginationProps()} />
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </AppContext.Consumer>
        );
    }
}
